import PropTypes from "prop-types";
import React from "react";
import { Controller } from "react-hook-form";
import { Label } from "reactstrap";
import MessageFormValidateV2 from "../MessageFormValidateV2";
import ModelDependHubSelect from "../ModelDependHubSelect";

/**
 * @param {object} props
 * @param {object} props.mainForm
 * @param {string} props.fieldName
 * @param {function} props.t
 * @param {boolean} props.isDisabled
 * @param {boolean} props.isRequired
 * @param {boolean} props.isMultiple
 * @param {?function} props.onChange
 * @param {string} props.title
 * @param {boolean} props.isLabel
 * @param {boolean} props.isError
 * @param {boolean} props.isClearable
 * @param {any} props.idModelDefault
 * @param {any} props.pathModel
 * @param {any} props.isFilterByHubSelect
 * @param {any} props.idHubFilterSelect

 */
const FormModelDependHubSelect = props => {
  const {
    pathModel,
    mainForm,
    fieldName,
    t,
    isDisabled,
    isRequired,
    isMultiple,
    onChange,
    title,
    isLabel,
    isError,
    isClearable,
    idModelDefault,
    isFilterByHubSelect,
    idHubFilterSelect,
  } = props;

  const {
    formState: { errors, touchedFields },
    control,
    setValue,
    watch,
  } = mainForm;

  const data = watch(fieldName);
  return (
    <div className={`${isLabel ? "mb-3" : ""}`}>
      {isLabel && (
        <Label htmlFor={fieldName}>
          {title || t(`form.${fieldName}`)}{" "}
          {isRequired && <span className="text-danger">*</span>}
        </Label>
      )}
      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => {
          return (
            <ModelDependHubSelect
              {...field}
              title={title}
              fieldName={fieldName}
              idModelDefault={idModelDefault}
              setValue={setValue}
              isDisabled={isDisabled}
              pathModel={pathModel}
              isFilterByHubSelect={isFilterByHubSelect}
              idHubFilterSelect={idHubFilterSelect}
            />
          );
        }}
      />
      {isError && (
        <MessageFormValidateV2 errors={errors} fieldName={fieldName} />
      )}
    </div>
  );
};

FormModelDependHubSelect.propTypes = {
  mainForm: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isMultiple: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.string,
  isLabel: PropTypes.bool,
  isError: PropTypes.bool,
  isClearable: PropTypes.bool,
  idModelDefault: PropTypes.any,
  isFilterByHubSelect: PropTypes.any,
  idHubFilterSelect: PropTypes.any,
};

FormModelDependHubSelect.defaultProps = {
  isDisabled: false,
  isRequired: false,
  isMultiple: false,
  onChange: () => {},
  title: "",
  isLabel: true,
  isError: true,
  isClearable: true,
  pathModel: "",
};

export default FormModelDependHubSelect;
